import Profile from './profile';
import Title from '../../../../components/dialog/title';
import Support from './support';
import Settings from './settings';
import About from './about';

const CurrentDialog = ({
  dialogRef,
  closeDialog,
  currentMenu,
  newUserInfo,
  infoChanged,
  handleNewUserInfo,
  handleSubmit,
  preference,
  updateUserPreference,
}) => {
  return (
    <dialog
      ref={dialogRef}
      className='px-4 py-2 w-full h-full max-w-lg max-h-full'
    >
      <Title
        title={currentMenu}
        onClick={closeDialog}
      />
      {currentMenu === 'Settings' && (
        <Settings
          newUserInfo={newUserInfo}
          preference={preference}
          updateUserPreference={updateUserPreference}
        />
      )}
      {currentMenu === 'My Profile' && (
        <Profile
          newUserInfo={newUserInfo}
          infoChanged={infoChanged}
          handleNewUserInfo={handleNewUserInfo}
          handleSubmit={handleSubmit}
          preference={preference}
        />
      )}
      {currentMenu === 'Question & Feedback' && (
        <Support newUserInfo={newUserInfo} />
      )}
      {currentMenu === 'About' && <About />}
    </dialog>
  );
};

export default CurrentDialog;
